import {
  getAcuteLearningPaths,
  getAcuteLearningPathsForUser,
  getAmbulatoryLearningPathsForUser,
} from "../../api";
import { createShadowRoot, html } from "../../lib";
import {
  createAcuteLearningPathInputDialog,
  createLearningPathInputDialog,
} from "./input-dialog";
import { createLoader } from "../loader";
import { createWarning } from "../warning";

const template = document.createElement("template");

const enrolledContainerId = "enrolled";
const showButtonId = "show";
const dialogContainerId = "dialog-container";

template.innerHTML = html`
  <style>
    * {
      box-sizing: border-box;
      list-style: none;
      margin: 0;
      padding: 0;
    }

    label {
      color: #595959;
      font-weight: bold;
    }

    .button-container > div {
      border-color: rgba(0, 0, 0, 0.4);
      border-radius: 4px;
      border-style: solid;
      border-width: 1px;

      padding: 20px 10px;
    }

    ul > li {
      color: rgba(0, 0, 0, 0.6);
    }

    button {
      background-color: transparent;
      border-color: rgb(57, 73, 171);
      border-radius: 4px;
      border-width: 1px;
      color: rgb(57, 73, 171);
      font-family: Roboto, sans-serif;
      font-size: 0.875rem;
      font-weight: 500;
      height: 36px;
      letter-spacing: 0.0892857143em;
      padding: 0px 16px;
      text-transform: uppercase;
    }

    button:hover {
      background-color: transparent;
    }
  </style>

  <label>Acute</label>
  <div class="button-container">
    <ul id="${enrolledContainerId}"></ul>
    <button id="${showButtonId}">Update</button>
  </div>

  <div id="${dialogContainerId}"></div>
`;

class El extends HTMLElement {
  #enrolledContainer;
  #showButton;
  #dialogContainer;

  constructor() {
    super();

    const { getElementById } = createShadowRoot(this, template);

    this.#enrolledContainer = getElementById(enrolledContainerId);
    this.#showButton = getElementById(showButtonId);

    this.#dialogContainer = getElementById(dialogContainerId);
  }

  set enrolled(list) {
    this.#enrolledContainer.replaceChildren(list);
  }

  set open(show) {
    this.#showButton.onclick = show;
  }

  set dialog(dialog) {
    this.#dialogContainer.replaceChildren(dialog);
  }
}

customElements.define("o-learning-path-acute-input", El);

export const createAcuteLearningPathInput = ({
  saDisplayName,
  userPrincipalName,
}) => {
  const el = new El();
  let enrolled;

  const refreshEnrolled = async () => {
    el.enrolled = createLoader(
      `Loading acute learning paths for ${userPrincipalName}`
    );
    const enrolledResponse = await getAcuteLearningPathsForUser({
      saDisplayName,
      userPrincipalName,
    });
    if (enrolledResponse instanceof Error) {
      el.enrolled = createWarning(
        `Unable to load acute learning paths for ${userPrincipalName}`
      );
      return 0;
    }

    enrolled = enrolledResponse;

    const list = document.createElement("ul");
    list.replaceChildren(...enrolled.map(createEnrolledItem));
    el.enrolled = list;
  };

  const dialog = createAcuteLearningPathInputDialog({
    saDisplayName,
    userPrincipalName,
    closedCb: refreshEnrolled,
  });
  el.dialog = dialog.el;

  const open = async () => {
    await dialog.open(enrolled);
  };
  el.open = open;

  return {
    el,
    init: refreshEnrolled,
  };
};

const createEnrolledItem = learningPath => {
  const li = document.createElement("li");
  li.textContent = learningPath.displayName;
  return li;
};
